import { useInject } from 'dependable-react';

import { MoreMagicType } from '../enums/MoreMagicType';
import { APP_DATA_TOKEN } from '../services/InjectTokens';
import { Avatar, Magic } from '../state/models';
import { deapify } from '../utils/apify';

export const useVariables = (avatars: Array<Avatar>, magicPersons?: Magic) => {
  const appState = useInject(APP_DATA_TOKEN);
  const magicPersonsRegex = /friendsName\w+/g;
  const magicPersonsDefaults = Object.keys(appState.translations[appState.currentLanguage])
    .filter((key) => key.includes('Default') && key.match(magicPersonsRegex))
    .map((key) => ({ [key.replace('Default', '')]: appState.translations[appState.currentLanguage][key] }))
    .reduce((acc, curr) => ({ ...curr, ...acc }), {});

  const dedicationMagic = appState.moreMagic.find((magic) => magic.type === MoreMagicType.DEDICATION);
  let dedication = '';
  if (dedicationMagic && dedicationMagic.params && dedicationMagic.params.dedication) {
    dedication = dedicationMagic.params.dedication;
  }

  const _avatars = avatars
    .map((avatar) => deapify(avatar.params) as Avatar['params'])
    .reduce((acc, curr) => ({ ...curr, ...acc }), {});

  const avatarDefaults = avatars
    .map((avatar) => deapify(avatar.defaultValues[appState.currentLanguage]) as Avatar['defaultValues'])
    .reduce((acc, curr) => ({ ...curr, ...acc }), {});

  if (magicPersons) {
    return {
      ...magicPersonsDefaults,
      ...avatarDefaults,
      ...deapify(magicPersons.params),
      ...(dedication && { dedication }),
      ..._avatars,
    };
  }

  return {
    ...magicPersonsDefaults,
    ...avatarDefaults,
    ..._avatars,
    ...(dedication && { dedication }),
  };
};


